/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Patient view model information returned from a basic patient search
 */
export interface PatientSimpleIntegrationViewModel {
  /**
   * Dataset Id
   */
  datasetId?: string;
  /**
   * Patient account number
   */
  accountNumber?: string | null;
  /**
   * Patient first name, max length 50
   */
  firstName?: string | null;
  /**
   * Patient middle name, max length 50
   */
  middleName?: string | null;
  /**
   * Patient last name, max length 50
   */
  lastName?: string | null;
  /**
   * Patient first and last name
   */
  firstLastName?: string | null;
  /**
   * Patient SSN, max length 11
   */
  ssn?: string | null;
  /**
   * Patient Medical Record Number
   */
  medicalRecordNumber?: string | null;
  /**
   * Patient Gender. (M)ale, (F)emale, (O)ther are valid values.
   */
  gender?: string | null;
  /**
   * Patient Date of Birth
   */
  birthDate?: string;
}
